import React from 'react'
import { Link, useParams } from 'react-router-dom'

import SEO from '../components/SEO'
import Navigation from '../components/navigation'
import Footer from '../components/footer'
import { blogPosts } from '../data/blogData'
import './blog-detail.css'

const BlogDetail = () => {
  const { slug } = useParams()
  const post = blogPosts.find((p) => p.slug === slug)

  if (!post) {
    return (
      <div className="blog-detail-container teleport-dashboard-layout">
        <SEO
          title="Rehber Bulunamadı | ATEŞ AUTO DETAILING"
          description="Aradığınız detailing veya araç koruma rehberi bulunamadı."
          canonicalPath="/blog"
          noindex={true}
        />
        <aside className="blog-sidebar-wrapper teleport-dashboard-sidebar">
          <Navigation />
        </aside>
        <main id="tq-main" className="blog-detail-content teleport-dashboard-content">
          <div className="blog-not-found-box">
            <h1 className="blog-not-found-title">Rehber Bulunamadı</h1>
            <p className="blog-not-found-text">
              Aradığınız makale mevcut değil veya taşınmış olabilir.
            </p>
            <Link to="/blog" className="blog-back-btn">
              ← Blog ve Rehber Ana Sayfasına Dön
            </Link>
          </div>
          <Footer />
        </main>
      </div>
    )
  }

  // Diğer önerilen rehberler
  const otherPosts = blogPosts.filter((p) => p.slug !== slug).slice(0, 3)

  return (
    <div className="blog-detail-container teleport-dashboard-layout">
      <SEO
        title={`${post.metaTitle} | ATEŞ AUTO DETAILING`}
        description={post.metaDesc}
        canonicalPath={`/blog/${post.slug}`}
      />

      <aside className="blog-sidebar-wrapper teleport-dashboard-sidebar">
        <Navigation />
      </aside>

      <main id="tq-main" className="blog-detail-content teleport-dashboard-content">
        <article className="blog-article-root">
          {/* Hero / Header Alanı (Tam Genişlik) */}
          <header className="blog-article-hero">
            <nav aria-label="Breadcrumb" className="blog-breadcrumb">
              <Link to="/">ANA SAYFA</Link>
              <span className="blog-breadcrumb-separator">/</span>
              <Link to="/blog">BLOG</Link>
              <span className="blog-breadcrumb-separator">/</span>
              <span aria-current="page">{post.badge}</span>
            </nav>

            <div className="blog-article-meta-top">
              <span className="blog-article-badge">{post.badge}</span>
              <span className="blog-article-date">{post.publishDate}</span>
              <span className="blog-meta-dot">•</span>
              <span className="blog-article-readtime">{post.readTime}</span>
            </div>

            <h1 className="blog-article-headline">{post.title}</h1>

            <div className="blog-article-author-bar">
              <span className="blog-author-label">Yazar / Editör:</span>
              <span className="blog-author-name">{post.author}</span>
              <span className="blog-meta-dot">•</span>
              <span className="blog-author-studio">Conrad İstanbul Bosphorus Stüdyosu</span>
            </div>
          </header>

          {/* Makale Gövdesi (Standart Sayfa Genişliği) */}
          <div className="blog-article-body-wrapper">
            {/* Kapak Görseli */}
            <div className="blog-featured-media">
              <img
                src={post.image}
                alt={post.imageAlt}
                className="blog-featured-img"
                loading="eager"
              />
              <p className="blog-img-caption">
                Ateş Auto Detailing stüdyosunda profesyonel uygulama anı ve detay finisajı.
              </p>
            </div>

            {/* Makale Özeti / Lead Giriş */}
            <div className="blog-lead-box">
              <p className="blog-lead-text">{post.summary}</p>
            </div>

            {/* Makale Ana Metni & Bölümleri */}
            <div className="blog-article-body">
              {post.sections.map((section, sIdx) => (
                <section key={sIdx} className="blog-section-block">
                  <h2 className="blog-section-heading">{section.h2}</h2>
                  {section.content.map((paragraph, pIdx) => (
                    <p key={pIdx} className="blog-paragraph">
                      {paragraph}
                    </p>
                  ))}
                </section>
              ))}
            </div>

            {/* İlgili Ticari Hizmete Bağlantı Kutusu */}
            {post.relatedService && (
              <div className="blog-related-service-card">
                <div className="blog-related-service-text">
                  <span className="blog-related-service-badge">İLGİLİ HİZMETİMİZ</span>
                  <h3 className="blog-related-service-title">{post.relatedService.title}</h3>
                  <p className="blog-related-service-desc">
                    Beşiktaş Conrad stüdyomuzda bu uygulamanın standartlarını ve fiyat tekliflerini inceleyin.
                  </p>
                </div>
                <Link to={post.relatedService.link} className="blog-related-service-btn">
                  {post.relatedService.cta} →
                </Link>
              </div>
            )}

            {/* Stüdyo Randevu & Danışma Banner */}
            <div className="blog-appointment-banner">
              <div className="blog-appointment-content">
                <h3 className="blog-appointment-title">Aracınız İçin Uzman Görüşü Alın</h3>
                <p className="blog-appointment-desc">
                  Aracınızın mevcut boya kondisyonuna uygun en doğru koruma ve detailing çözümü için
                  Beşiktaş Conrad stüdyomuzla iletişime geçebilir, randevu oluşturabilirsiniz.
                </p>
              </div>
              <div className="blog-appointment-actions">
                <a
                  href="https://wa.me/905346442153"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="blog-cta-whatsapp"
                >
                  WhatsApp&apos;tan Danış
                </a>
                <a href="tel:05346442153" className="blog-cta-phone">
                  0534 644 21 53
                </a>
              </div>
            </div>

            {/* Diğer Rehberler Bölümü */}
            <div className="blog-other-guides-section">
              <h2 className="blog-other-guides-title">Diğer Uzman Rehberleri</h2>
              <div className="blog-other-guides-grid">
                {otherPosts.map((other, idx) => (
                  <article key={idx} className="blog-mini-card">
                    <div className="blog-mini-img-wrapper">
                      <img
                        src={other.image}
                        alt={other.imageAlt}
                        className="blog-mini-img"
                        loading="lazy"
                      />
                      <span className="blog-mini-badge">{other.badge}</span>
                    </div>
                    <div className="blog-mini-info">
                      <span className="blog-mini-readtime">{other.readTime}</span>
                      <h3 className="blog-mini-title">
                        <Link to={`/blog/${other.slug}`}>{other.title}</Link>
                      </h3>
                      <Link to={`/blog/${other.slug}`} className="blog-mini-link">
                        Rehberi İncele →
                      </Link>
                    </div>
                  </article>
                ))}
              </div>
            </div>
          </div>
        </article>

        <Footer />
      </main>
    </div>
  )
}

export default BlogDetail
